import { useTranslation } from 'react-i18next';
import { MetricsContainer } from '@/features/metrics/containers/metrics-container';

export default function MetricsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">{t('metrics.title')}</h1>
      <MetricsContainer />
    </div>
  );
}
